<template>
  <div>
    <TableFilters
      :filters="['dateRange', 'product', 'shop']"
      v-model="filter"
      :columns="false"
    ></TableFilters>
    <v-row class="py-0 my-0">
      <v-col cols="12" md="12" lg="7" class="pa-5">
        <v-btn-toggle v-model="toggle_exclusive">
          <v-btn @click="viewpdfFile()"> View Report </v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>

    <div v-show="false">
      <v-btn
        style="padding: 10px; margin: 15px"
        depressed
        block
        small
        @click="FilterDailyStock"
      >
        <v-icon class="icon_small">mdi-filter </v-icon>
      </v-btn>

      <v-card class="lighten-12 card-content mb-2">
        <v-data-table
          :headers="headers"
          :items="DailyStockListShop"
          item-key="date"
          class="row-pointer"
        >
        </v-data-table>
      </v-card>
    </div>
  </div>
</template>

<script>
import TableFilters from '@/components/base/TableFilters';
import pagination from '../../modules/shared/components/pagination.vue';
import axios from '@/plugins/axios';

export default {
  data() {
    return {
      filter: '',
      headers: [
        {
          text: 'Date',
          value: 'date',

          width: '10%',
          align: 'left',
          render: (item) => item?.date,
        },
        {
          text: 'Available Stock',
          value: 'available_stock',

          width: '10%',
          align: 'left',
          render: (item) => item?.available_stock,
        },
      ],
      DailyStockListShop: [],
    };
  },
  components: {
    TableFilters,
    pagination,
  },
  created() {
    this.$store.commit('UPDATE_PDF_VISIBLE', false);
    this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
  },
  methods: {
    FilterDailyStock(callBack = () => {}) {
      if (this.filter.start && this.filter.end) {
        let url = `dashboard/daily-stocks/shops/${this.filter.shop}/date-range?product=${this.filter.product}&start=${this.filter.start}&end=${this.filter.end}`;
        axios
          .get(url)
          .then((res) => {
            this.DailyStockListShop = res.data.data;
            setTimeout(() => {
              callBack();
              // Update Pdf To List
              this.$store.commit('UPDATE_PDF_HEADERS', this.headers);
              // Update Pdf To List Datas
              this.$store.commit('UPDATE_PDF_DATAS', this.DailyStockListShop);
              // Update Pdf To List_Title
              this.$store.commit('UPDATE_PDF_TITLE', 'Daily Shop Stock');
              this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
            }, 100);
          })
          .catch((err) => {
            this.data = [];
          });
      } else {
        this.$confirm('Please Select the Date then Try?');
      }
    },
    async viewpdfFile() {
      await this.FilterDailyStock();
      setTimeout(() => {
        if (this.DailyStockListShop.length > 0) {
          this.$store.commit('UPDATE_PDF_VISIBLE', true);
          this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
        }
      }, 400);
    },
  },
};
</script>
